
import imModal from '../imModal'

export default {
    name: 'BuyerRefundAccount',
    components: {
        imModal
    },
    props: {
        content: {
            type: Object,
            default: () => ({})
        },
        mentionedUser: {
            type: String,
            default: ''
        }
    },
    data () {
        return {
            isShow: false,
            btnLoading: false,
            paymentInfoForm: {
                paymentType: '1'
            },
            rule: {
                paymentType: [{ required: true, message: '请选择收款账户类型', trigger: 'change' }],
                realName: [{ required: true, message: '请输入真实姓名', trigger: 'blur' }],
                paymentAccount: [{ required: true, message: '请输入收款账户', trigger: 'blur' }],
                confirmPaymentAccount: [
                    { required: true, message: '请输入确认收款账户', trigger: 'blur' },
                    { validator: this.validateAccount, trigger: 'blur' }
                ]
            }
        }
    },
    computed: {
        formattedText () {
            if (!this.content?.text) {
                return ''
            }
            // 使用正则表达式匹配"退差价XXX元"并用span标签包裹
            return this.content.text.replace(
                /(退差价\d+(?:\.\d+)?元)/g,
                '<span>$1</span>'
            )
        }
    },
    methods: {
        validateAccount (_, value, callback) {
            if (value !== this.paymentInfoForm.paymentAccount) {
                callback(new Error('收款账户与确认收款账户不一致'))
            } else {
                callback()
            }
        },
        openForm () {
            this.isShow = true
            this.paymentInfoForm = {
                ...this.content,
                realName: '',
                paymentAccount: '',
                confirmPaymentAccount: '',
                paymentType: '1'
            }
            this.$nextTick(() => {
                this.$refs.paymentInfoForm.resetFields()
            })
        },
        submit () {
            this.$refs.paymentInfoForm.validate(valid => {
                if (valid) {
                    this.btnLoading = true
                    this.$api.submitCancelBuyerAccount(this.paymentInfoForm).then(res => {
                        if (res.success) {
                            this.isShow = false
                            this.$message.success('提交成功')
                        } else {
                            this.$message.error(res.info)
                        }
                    }).finally(() => {
                        this.btnLoading = false
                    })
                }
            })
        }
    }
}
